var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49983 3.74121C6.62702 3.74121 5.91947 4.44876 5.91947 5.32157C5.91947 6.19438 6.62702 6.90193 7.49983 6.90193C8.37263 6.90193 9.08018 6.19438 9.08018 5.32157C9.08018 4.44876 8.37263 3.74121 7.49983 3.74121ZM4.79447 5.32157C4.79447 3.82744 6.0057 2.61621 7.49983 2.61621C8.99395 2.61621 10.2052 3.82744 10.2052 5.32157C10.2052 6.8157 8.99395 8.02693 7.49983 8.02693C6.0057 8.02693 4.79447 6.8157 4.79447 5.32157ZM3.44399 9.83716C3.95134 9.32981 4.63946 9.04478 5.35697 9.04478H9.64268C10.3602 9.04478 11.0483 9.32981 11.5557 9.83716C12.063 10.3445 12.348 11.0326 12.348 11.7501V12.8216C12.348 13.1322 12.0962 13.3841 11.7855 13.3841C11.4749 13.3841 11.223 13.1322 11.223 12.8216V11.7501C11.223 11.331 11.0565 10.929 10.7602 10.6327C10.4638 10.3363 10.0618 10.1698 9.64268 10.1698H5.35697C4.93783 10.1698 4.53586 10.3363 4.23949 10.6327C3.94311 10.929 3.77661 11.331 3.77661 11.7501V12.8216C3.77661 13.1322 3.52477 13.3841 3.21411 13.3841C2.90345 13.3841 2.65161 13.1322 2.65161 12.8216V11.7501C2.65161 11.0326 2.93664 10.3445 3.44399 9.83716Z",
    fill: "#748399"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.b10496c7852c2047786e36d3b3ae12a5.svg";
export { ForwardRef as ReactComponent };